/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_graasp_library_description24 = /** @type {(inputs: {}) => string} */ () => {
	return `Graasp Library is a platform for sharing free and open source educational resources.`
};

const fr_graasp_library_description24 = /** @type {(inputs: {}) => string} */ () => {
	return `Graasp Library est une plateforme de partage de ressources éducatives libres.`
};

const de_graasp_library_description24 = /** @type {(inputs: {}) => string} */ () => {
	return `Graasp Library ist eine Open-Source-Plattform, die Lernressourcen als Ressourcen bereitstellt.`
};

const es_graasp_library_description24 = /** @type {(inputs: {}) => string} */ () => {
	return `La Biblioteca de Graasp es una plataforma de código abierto que ofrece recursos educativos.`
};

const it_graasp_library_description24 = /** @type {(inputs: {}) => string} */ () => {
	return `Graasp Library è una piattaforma open source che fornisce risorse di apprendimento come raccolte.`
};

const ar_graasp_library_description24 = /** @type {(inputs: {}) => string} */ () => {
	return `مكتبة چراسپ عبارة عن منصّة مفتوحة المصدر التي توفر موارد تعليمية كمجموعات.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const graasp_library_description24 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.graasp_library_description24(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("graasp_library_description24", locale)
	if (locale === "en") return en_graasp_library_description24(inputs)
	if (locale === "fr") return fr_graasp_library_description24(inputs)
	if (locale === "de") return de_graasp_library_description24(inputs)
	if (locale === "es") return es_graasp_library_description24(inputs)
	if (locale === "it") return it_graasp_library_description24(inputs)
	return ar_graasp_library_description24(inputs)
};
export { graasp_library_description24 as "GRAASP_LIBRARY_DESCRIPTION" }